import withStyles from 'material-ui/styles/withStyles'
import React from 'react'
import styleSheet from './AllWebChatStyle.style'

class WebChatSearchForm extends React.Component {
  state = { content: '' }

  onSearch(e) {
    e.preventDefault()
    window.location.href = `faq_search?keyword=${this.state.content}&commit=検索`
  }

  handleSearch(content) {
    this.setState({ content })
  }

  render() {
    const classes = this.props.classes
    return (
      <div className={classes.searchForm}>
        <div className={classes.searchForm_firstDiv}>
          <h3 className={classes.searchForm_title}>他の人の相談から探す</h3>
        </div>
        <div>
          <form onSubmit={(e) => this.onSearch(e)} className={classes.searchForm_submit}>
            <span className={`glyphicon glyphicon-search ${classes.searchForm_icon}`}></span>
            <input
              type="text"
              value={this.state.content}
              placeholder="病名、症状、検査、お薬名から探す"
              onChange={(e) => this.handleSearch(e.target.value)}
              className={classes.searchForm_input}
            />
          </form>
        </div>
      </div>
    )
  }
}

export default withStyles(styleSheet)(WebChatSearchForm)
